export function tableReportWorkers(HelperTable) {

    const selectorTable = '#table-report-workers';
    const elTable = $(selectorTable)

    if (!elTable.length) {
        return;
    }

    let columns = [];

    columns = [
        {
            label: ESR.lang.id,
            data: 'id',
            className: 'id min-tablet-p',
            visible: true
        },
        {
            label: ESR.lang.user_name,
            data: 'name',
            className: 'name min-tablet-p',
            visible: true
        },
        {
            label: ESR.lang.total,
            data: 'total',
            className: 'total min-tablet-p',
            visible: true
        },
        {
            label: ESR.lang.works_ids,
            data: 'work_ids',
            className: 'work_ids min-tablet-p',
            visible: false
        }
    ];


    const myTableHeader = HelperTable.createRowHeader(columns);
    const myTableFooter = HelperTable.createRowFooterEmpty(columns)
    elTable.append(myTableHeader)
    elTable.append(myTableFooter)

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        order: [
            [2, 'dsc']
        ],
        // stateSave: true,
        processing: false,
        serverSide: false,
        info: false,
        layout: {
            // topStart: toolbar,
            topStart: {
                buttons: [
                    // 'pageLength',
                    {
                        extend: 'colvis',
                        className: 'btn btn-sm btn-neutral',
                    },
                    {
                        extend: 'collection',
                        text: ESR.lang.export,
                        className: 'btn btn-sm btn-neutral btn-export',
                        buttons: [
                            {
                                extend: 'excelHtml5',
                                exportOptions: {
                                    modifier: {selected: null}, // all pages
                                    columns: ':visible'
                                }
                            },
                            {
                                extend: 'pdf',
                                text: 'PDF',
                                exportOptions: {
                                    modifier: {selected: null}, // all pages
                                    columns: ':visible'
                                }
                            },
                            {
                                extend: 'print',
                                text: ESR.lang.print,
                                exportOptions: {
                                    modifier: {selected: null}, // all pages
                                    columns: ':visible'
                                }
                            }
                        ]
                    },

                ]
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
            buttons: {
                // colvis: 'Coloane',
            }
        },
        displayLength: 100,
        footerCallback: function (tfoot) {
            let api = this.api();
            const indexColTotal = 2;
            const sumTotal = api.column(indexColTotal).data().reduce((a, b) => ESR.Helper.toFloat(a) + ESR.Helper.toFloat(b), 0);
            api.column(indexColTotal).footer().innerHTML = sumTotal.toFixed(2);
        }
    });

}